import { render, staticRenderFns } from "./termProfile.vue?vue&type=template&id=1108be75&"
import script from "./termProfile.vue?vue&type=script&lang=js&"
export * from "./termProfile.vue?vue&type=script&lang=js&"
import style0 from "./termProfile.vue?vue&type=style&index=0&id=1108be75&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports